export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/index.vue'),
    /* no children */
    meta: {
      "title": "主页",
      "i18n": "menus.home"
    }
  },
  {
    path: '/:all(.*)',
    name: '404',
    component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/[...all].vue'),
    /* no children */
    meta: {
      "title": "404",
      "i18n": "menus.404Demo"
    }
  },
  {
    path: '/404',
    /* internal name: '/404' */
    /* no component */
    children: [
      {
        path: '',
        name: '/404/',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/404/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/activity',
    /* internal name: '/activity' */
    /* no component */
    children: [
      {
        path: '',
        name: 'activity',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/index.vue'),
        /* no children */
        meta: {
          "title": "活动",
          "i18n": "menus.activity"
        }
      },
      {
        path: 'components',
        /* internal name: '/activity/components' */
        /* no component */
        children: [
          {
            path: 'activityIndex',
            /* internal name: '/activity/components/activityIndex' */
            /* no component */
            children: [
              {
                path: 'ComissaoDe',
                name: 'ComissaoDes',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/ComissaoDe.vue'),
                /* no children */
                meta: {
                  "title": "ComissaoDes",
                  "i18n": "menus.ComissaoDes"
                }
              },
              {
                path: 'Custom',
                name: '/activity/components/activityIndex/Custom',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/Custom.vue'),
                /* no children */
              },
              {
                path: 'dailyCashback',
                name: 'dailyCashback',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/dailyCashback.vue'),
                /* no children */
                meta: {
                  "title": "menus.dailyCashback",
                  "i18n": "menus.dailyCashback"
                }
              },
              {
                path: 'Detalhes',
                name: 'Detalhes',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/Detalhes.vue'),
                /* no children */
                meta: {
                  "title": "Detalhes",
                  "i18n": "menus.Detalhes"
                }
              },
              {
                path: 'entrada',
                name: 'entrada',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/entrada.vue'),
                /* no children */
                meta: {
                  "title": "entrada",
                  "i18n": "menus.entrada"
                }
              },
              {
                path: 'facebook',
                name: 'facebook',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/facebook.vue'),
                /* no children */
                meta: {
                  "title": "facebook",
                  "i18n": "menus.facebook"
                }
              },
              {
                path: 'indiqueAmigos',
                name: 'IndiqueAmigos',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/indiqueAmigos.vue'),
                /* no children */
                meta: {
                  "title": "IndiqueAmigos",
                  "i18n": "menus.IndiqueAmigos"
                }
              },
              {
                path: 'Membros',
                name: 'Membros',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/Membros.vue'),
                /* no children */
                meta: {
                  "title": "Membros",
                  "i18n": "menus.Membros"
                }
              },
              {
                path: 'Misteriosa',
                name: '/activity/components/activityIndex/Misteriosa',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/Misteriosa.vue'),
                /* no children */
              },
              {
                path: 'newUsers',
                name: '/activity/components/activityIndex/newUsers',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/newUsers.vue'),
                /* no children */
              },
              {
                path: 'pesquisar',
                name: 'pesquisar',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/pesquisar.vue'),
                /* no children */
                meta: {
                  "title": "pesquisar",
                  "i18n": "menus.pesquisar"
                }
              },
              {
                path: 'reembolso',
                name: 'reembolso',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/reembolso.vue'),
                /* no children */
                meta: {
                  "title": "Taxa de reembolso",
                  "i18n": "menus.reembolso"
                }
              },
              {
                path: 'Telegram',
                name: 'telegram',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/Telegram.vue'),
                /* no children */
                meta: {
                  "title": "telegram",
                  "i18n": "menus.telegram"
                }
              },
              {
                path: 'turntable',
                name: '/activity/components/activityIndex/turntable',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/turntable.vue'),
                /* no children */
              },
              {
                path: 'vipavtivity',
                name: 'VipActivity',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/vipavtivity.vue'),
                /* no children */
                meta: {
                  "title": "VipActivity",
                  "i18n": "menus.VipActivity"
                }
              },
              {
                path: 'weekCashback',
                name: 'weekCashback',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/weekCashback.vue'),
                /* no children */
                meta: {
                  "title": "menus.weekCashback",
                  "i18n": "menus.weekCashback"
                }
              },
              {
                path: 'whatsapp',
                name: 'whatsapp',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activityIndex/whatsapp.vue'),
                /* no children */
                meta: {
                  "title": "whatsapp",
                  "i18n": "menus.whatsapp"
                }
              }
            ],
          },
          {
            path: 'activitys',
            name: '/activity/components/activitys',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/activitys.vue'),
            /* no children */
          },
          {
            path: 'codes',
            name: '/activity/components/codes',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/codes.vue'),
            /* no children */
          },
          {
            path: 'historico',
            name: '/activity/components/historico',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/historico.vue'),
            /* no children */
          },
          {
            path: 'MysteriousLottery',
            name: '/activity/components/MysteriousLottery',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/MysteriousLottery.vue'),
            /* no children */
          },
          {
            path: 'pendente',
            name: '/activity/components/pendente',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/pendente.vue'),
            /* no children */
          },
          {
            path: 'rebate',
            name: '/activity/components/rebate',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/rebate.vue'),
            /* no children */
          },
          {
            path: 'vip',
            name: '/activity/components/vip',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/vip.vue'),
            children: [
              {
                path: 'Recompensas',
                name: '/activity/components/vip/Recompensas',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/vip/Recompensas.vue'),
                /* no children */
              },
              {
                path: 'VipBonusDaily',
                name: '/activity/components/vip/VipBonusDaily',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/vip/VipBonusDaily.vue'),
                /* no children */
              },
              {
                path: 'VipBonusMonthly',
                name: '/activity/components/vip/VipBonusMonthly',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/vip/VipBonusMonthly.vue'),
                /* no children */
              },
              {
                path: 'VipBonusTable',
                name: '/activity/components/vip/VipBonusTable',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/vip/VipBonusTable.vue'),
                /* no children */
              },
              {
                path: 'VipBonusWeekly',
                name: '/activity/components/vip/VipBonusWeekly',
                component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/vip/VipBonusWeekly.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'wakdog',
            name: '/activity/components/wakdog',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/components/wakdog.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'index1',
        name: 'activity1',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/activity/index1.vue'),
        /* no children */
        meta: {
          "title": "活动",
          "i18n": "menus.activity"
        }
      }
    ],
  },
  {
    path: '/bonusRecord',
    /* internal name: '/bonusRecord' */
    /* no component */
    children: [
      {
        path: '',
        name: 'bonusRecord',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/bonusRecord/index.vue'),
        /* no children */
        meta: {
          "title": "Registro de Depósito",
          "i18n": "menus.bonusRecord"
        }
      }
    ],
  },
  {
    path: '/ConvidarCentro',
    /* internal name: '/ConvidarCentro' */
    /* no component */
    children: [
      {
        path: '',
        name: 'ConvidarCentro',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/ConvidarCentro/index.vue'),
        /* no children */
        meta: {
          "title": "ConvidarCentro",
          "i18n": "menus.convidarCentro"
        }
      },
      {
        path: 'components',
        /* internal name: '/ConvidarCentro/components' */
        /* no component */
        children: [
          {
            path: '/casseindex',
            name: 'casseindex',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/ConvidarCentro/components/casseindex.vue'),
            /* no children */
            meta: {
              "title": "Commission Details",
              "i18n": "menus.casseindex"
            }
          },
          {
            path: 'AgentBonusRate',
            name: '/ConvidarCentro/components/AgentBonusRate',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/ConvidarCentro/components/AgentBonusRate.vue'),
            /* no children */
          },
          {
            path: 'AgentNetwork',
            name: '/ConvidarCentro/components/AgentNetwork',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/ConvidarCentro/components/AgentNetwork.vue'),
            /* no children */
          },
          {
            path: 'Commission',
            name: '/ConvidarCentro/components/Commission',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/ConvidarCentro/components/Commission.vue'),
            /* no children */
          },
          {
            path: 'InviteLink',
            name: '/ConvidarCentro/components/InviteLink',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/ConvidarCentro/components/InviteLink.vue'),
            /* no children */
          },
          {
            path: 'Performance',
            name: '/ConvidarCentro/components/Performance',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/ConvidarCentro/components/Performance.vue'),
            /* no children */
          },
          {
            path: 'RegisterSub',
            name: '/ConvidarCentro/components/RegisterSub',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/ConvidarCentro/components/RegisterSub.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/Deposito',
    /* internal name: '/Deposito' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Deposito',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/Deposito/index.vue'),
        /* no children */
        meta: {
          "title": "Deposito",
          "i18n": "menus.deposito"
        }
      },
      {
        path: 'registroDeDeposito',
        name: 'registroDeDeposito',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/Deposito/registroDeDeposito.vue'),
        /* no children */
        meta: {
          "title": "Registro de Depósito",
          "i18n": "menus.registroDeDeposito"
        }
      }
    ],
  },
  {
    path: '/download',
    /* internal name: '/download' */
    /* no component */
    children: [
      {
        path: '',
        name: '/download/',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/download/index.vue'),
        /* no children */
      },
      {
        path: 'components',
        /* internal name: '/download/components' */
        /* no component */
        children: [
          {
            path: 'loading',
            name: '/download/components/loading',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/download/components/loading.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/findGameByVendor',
    /* internal name: '/findGameByVendor' */
    /* no component */
    children: [
      {
        path: '/findGameByVendor',
        name: 'findGameByVendor',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/findGameByVendor/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/forgot-password',
    /* internal name: '/forgot-password' */
    /* no component */
    children: [
      {
        path: '',
        name: 'forgot-password',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/forgot-password/index.vue'),
        /* no children */
        meta: {
          "i18n": "menus.forgot-password"
        }
      }
    ],
  },
  {
    path: '/gameLimit',
    /* internal name: '/gameLimit' */
    /* no component */
    children: [
      {
        path: '/gameLimit',
        name: 'gameLimit',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/gameLimit/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/keepalive',
    /* internal name: '/keepalive' */
    /* no component */
    children: [
      {
        path: '',
        name: 'KeepAlive',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/keepalive/index.vue'),
        /* no children */
        meta: {
          "title": "🧡 KeepAlive",
          "i18n": "menus.keepAlive",
          "keepAlive": true
        }
      }
    ],
  },
  {
    path: '/mensagens',
    /* internal name: '/mensagens' */
    /* no component */
    children: [
      {
        path: '',
        name: 'mensagens',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/mensagens/index.vue'),
        /* no children */
        meta: {
          "title": "Mensagens",
          "i18n": "menus.mensagens"
        }
      },
      {
        path: 'Detalhes',
        name: '/mensagens/Detalhes',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/mensagens/Detalhes.vue'),
        /* no children */
        meta: {
          "title": "Details",
          "keepAlive": true
        }
      }
    ],
  },
  {
    path: '/person',
    /* internal name: '/person' */
    /* no component */
    children: [
      {
        path: '',
        name: 'person',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/person/index.vue'),
        /* no children */
        meta: {
          "title": "个人中心",
          "i18n": "menus.person"
        }
      }
    ],
  },
  {
    path: '/profile',
    /* internal name: '/profile' */
    /* no component */
    children: [
      {
        path: '',
        name: 'profile',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/profile/index.vue'),
        /* no children */
        meta: {
          "title": "个人中心",
          "i18n": "menus.profile"
        }
      }
    ],
  },
  {
    path: '/register',
    /* internal name: '/register' */
    /* no component */
    children: [
      {
        path: '',
        name: 'register',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/register/index.vue'),
        /* no children */
        meta: {
          "i18n": "menus.register"
        }
      }
    ],
  },
  {
    path: '/relatorios',
    /* internal name: '/relatorios' */
    /* no component */
    children: [
      {
        path: '',
        name: 'relatorios',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/relatorios/index.vue'),
        /* no children */
        meta: {
          "title": "Reports",
          "i18n": "menus.relatorios"
        }
      },
      {
        path: 'components',
        /* internal name: '/relatorios/components' */
        /* no component */
        children: [
          {
            path: 'AccountDetails',
            name: '/relatorios/components/AccountDetails',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/relatorios/components/AccountDetails.vue'),
            /* no children */
          },
          {
            path: 'BettingRecords',
            name: '/relatorios/components/BettingRecords',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/relatorios/components/BettingRecords.vue'),
            /* no children */
          },
          {
            path: 'BettingStatistics',
            name: '/relatorios/components/BettingStatistics',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/relatorios/components/BettingStatistics.vue'),
            /* no children */
          },
          {
            path: 'Other',
            name: '/relatorios/components/Other',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/relatorios/components/Other.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/Search',
    /* internal name: '/Search' */
    /* no component */
    children: [
      {
        path: '',
        name: '/Search/',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/Search/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/security',
    /* internal name: '/security' */
    /* no component */
    children: [
      {
        path: '/security',
        name: 'security',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/security/index.vue'),
        /* no children */
        meta: {
          "title": "Security",
          "i18n": "menus.security"
        }
      },
      {
        path: 'email',
        name: 'email',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/security/email.vue'),
        /* no children */
        meta: {
          "title": "email",
          "i18n": "email"
        }
      },
      {
        path: 'parssord',
        name: 'parssord',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/security/parssord.vue'),
        /* no children */
        meta: {
          "title": "parssord",
          "i18n": "parssord"
        }
      },
      {
        path: 'resetPassword',
        name: 'resetPassword',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/security/resetPassword.vue'),
        /* no children */
        meta: {
          "title": "resetPassword"
        }
      },
      {
        path: 'senha',
        name: '/security/senha',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/security/senha.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: 'settings',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/settings/index.vue'),
        /* no children */
        meta: {
          "title": "我的设置",
          "i18n": "menus.settings"
        }
      }
    ],
  },
  {
    path: '/update',
    name: 'update',
    component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/update.vue'),
    /* no children */
    meta: {
      "title": "更新",
      "i18n": "menus.update"
    }
  },
  {
    path: '/wallet',
    /* internal name: '/wallet' */
    /* no component */
    children: [
      {
        path: '',
        name: 'wallet',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/wallet/index.vue'),
        /* no children */
        meta: {
          "title": "钱包",
          "i18n": "menus.wallet"
        }
      },
      {
        path: '/wallet/auditDetail',
        name: 'auditDetail',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/wallet/auditDetail.vue'),
        /* no children */
        meta: {
          "title": "Audit Detail",
          "i18n": "menus.auditDetail"
        }
      },
      {
        path: 'chargebackRecord',
        name: 'chargebackRecord',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/wallet/chargebackRecord.vue'),
        /* no children */
        meta: {
          "title": "Registro de Depósito",
          "i18n": "menus.chargebackRecord"
        }
      }
    ],
  },
  {
    path: '/webview',
    /* internal name: '/webview' */
    /* no component */
    children: [
      {
        path: 'components',
        /* internal name: '/webview/components' */
        /* no component */
        children: [
          {
            path: 'DraggableBall',
            name: '/webview/components/DraggableBall',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/webview/components/DraggableBall.vue'),
            /* no children */
          },
          {
            path: 'Tab',
            name: '/webview/components/Tab',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/webview/components/Tab.vue'),
            /* no children */
          },
          {
            path: 'Tabs',
            name: '/webview/components/Tabs',
            component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/webview/components/Tabs.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'index2',
        name: '/webview/index2',
        component: () => import('E:/xiangmu/vue3-vant-mobile/src/pages/webview/index2.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

